module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Snow#1-c6546709be6154c7a06b2efbe59b0801.svg";